import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setScreenSize } from '../redux/slices/responsive.slice';
import { RootState } from '../redux/store';

type ResponsiveState = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  screenWidth: number;
};

const useResponsive = (): ResponsiveState => {
  const dispatch = useDispatch();
  const responsive = useSelector((state: RootState) => state.responsive as ResponsiveState);
  const { isMobile, isTablet, isDesktop, screenWidth } = responsive;

  useEffect(() => {
    const handleResize = () => {
      dispatch(
        setScreenSize({
          width: window.innerWidth,
          height: window.innerHeight,
        })
      );
    };

    // Set initial size
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  return {
    isMobile,
    isTablet,
    isDesktop,
    screenWidth,
  } as ResponsiveState;
};

export default useResponsive;
